import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { OpeningLead } from '../components/OpeningLead';
import { EditorialTips } from '../components/EditorialTips';
import { PdfPreview } from '../components/PdfPreview';
import { Testimonials } from '../components/Testimonials';
import { WhatYouGet } from '../components/WhatYouGet';
import { Bonuses } from '../components/Bonuses';
import { PricingSection } from '../components/PricingSection';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { PriceComparison } from '../components/PriceComparison';
import { StickyCTA } from '../components/StickyCTA';
import { SocialProofToast } from '../components/SocialProofToast';
import { DiscountPopup } from '../components/DiscountPopup';
import { Footer } from '../components/Footer';
import { OrderBumpProvider } from '../hooks/useOrderBumps';
function SalesPageContent() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-sage/20" data-id="element-831">
      <Hero data-id="element-832" />
      <ProblemSection data-id="element-833" />
      <OpeningLead data-id="element-834" />
      <EditorialTips data-id="element-835" />
      <Testimonials data-id="element-836" />
      <PdfPreview data-id="element-837" />
      <WhatYouGet data-id="element-838" />
      <Bonuses data-id="element-839" />
      <PricingSection data-id="element-840" />
      <Guarantee data-id="element-841" />
      <FAQ data-id="element-842" />
      <PriceComparison data-id="element-843" />

      <Footer data-id="element-844" />
      <StickyCTA data-id="element-845" />
      <SocialProofToast data-id="element-846" />
      <DiscountPopup data-id="element-847" />
    </div>;
}
export function SalesPage() {
  return <OrderBumpProvider data-id="element-848">
      <SalesPageContent data-id="element-849" />
    </OrderBumpProvider>;
}